export default "curl \"https://api.test.com/\" -u \"some_username:some_password\"\n";